module.exports = __webpack_public_path__ + "img/aviator.5112da00.gif";